import { Component, OnInit, AfterViewInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import {TextItem} from './text-item/text-item';
import {PlayerComponent} from './player/player.component';
import {PlayerPoint} from './player/point';
import {PlayerChangePositionService} from './player/player-change-position-service';

import $ from 'jquery/dist/jquery.js'
import _ from 'underscore/underscore-min'

import {ImageItem} from "./image-item";
import {PodcastItem} from "./podcast-item";
import {MomentJsService} from "../services/momentjs.service";
import {User} from "../core/user";

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ModalComponent} from "../core/modals/modal/modal.component";
import {Globals} from "../globals";
import {TranslationService} from "../services/translation.service";
import {RemovePodcastComponent} from "../core/modals/remove-podcast/remove-podcast.component";


@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.scss'],
    providers: [ PlayerChangePositionService ]
})

export class EditorComponent implements OnInit, AfterViewInit {
    @Input() previewMode:boolean;
    podcastItem: PodcastItem;
    modalRef: BsModalRef;
    positionInterval: any;
    globalPreviewMode: boolean;
    embededMode: boolean;
    showWaitStatus:boolean;

    @ViewChild(PlayerComponent)
    private playerComponent: PlayerComponent;

    constructor(
        private http: HttpClient,
        private playerChangePositionService: PlayerChangePositionService,
        private momentJsService: MomentJsService,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: BsModalService,
        private globals: Globals,
        private translationService: TranslationService
    ) {}

    ngOnInit() {
        this.globalPreviewMode = this.globals.previeModeStatus();
        this.embededMode = this.globals.embededModeStatus();

        this.podcastItem = new PodcastItem();

        this.route.params.subscribe(params => {
            const podcastId = +params['id'];

            $('body').addClass('loading');

            const data =
                this.http
                .get('/editor/get?id=' + params['id'] + ( params['secret'] ? '&secret=' + params['secret'] : '') ).subscribe( (result:any) => {
                    let i = 1;

                    let existUrls = {};

                    this.podcastItem.id = result.id ? result.id : null;
                    this.podcastItem.name = result.name;
                    this.podcastItem.description = result.description;
                    this.podcastItem.podcastAudio = result.audio;
                    this.podcastItem.podcastAudioData = result.wave;
                    this.podcastItem.createDate = this.momentJsService.format(result.create_date, 'DD.MM.YYYY H:m');
                    this.podcastItem.parsedTags = result.parsed_tags;
                    this.podcastItem.secret = result.secret;

                    this.podcastItem.is_my = result.is_my;
                    this.podcastItem.is_public = result.is_public;

                    const user = new User();
                    user.first_name = result.user.first_name;
                    user.last_name = result.user.last_name;
                    user.name = result.user.name;
                    user.email = result.user.email;
                    user.phone_mobile = result.user.phone_mobile;

                    this.podcastItem.user = user;

                    that.podcastItem.currentPodcastImage = new ImageItem();

                    result.parsed_text.forEach( (item) => {
                        const textItem = new TextItem();

                        const imgItem = new ImageItem();
                        imgItem.url = item.image

                        textItem.text = item.text;
                        textItem.time = item.time;
                        textItem.image = imgItem;
                        textItem.id = i++;

                        that.podcastItem.textItems.push(textItem);

                        if (textItem.time === 0 || textItem.time) {
                            let point = new PlayerPoint();
                            point.id = textItem.id;
                            point.time = textItem.time;
                            // point.labelText = textItem.getAudioPointText();
                            point.editable = true;
                            that.podcastItem.stopPoints.push(point);
                        }

                        this.podcastItem.currentPodcastImage.url = this.podcastItem.currentPodcastImage.url||item.image

                        if(item.image) {
                            existUrls[item.image] = 1;
                        }
                    });

                    this.playerComponent.filePathAudio = this.podcastItem.podcastAudio;
                    this.playerComponent.filePathData = this.podcastItem.podcastAudioData;
                    this.playerComponent.initPlayer();
                    this.playerComponent.reinit();


                    result.images.forEach( (imgUrl) => {
                        let img = new ImageItem();
                        img.url = imgUrl;
                        img.isLinked = _.has(existUrls, imgUrl)
                        this.podcastItem.podcastImages.push(img);
                    });
                    if(!this.podcastItem.currentPodcastImage||!this.podcastItem.currentPodcastImage.url){
                        this.podcastItem.currentPodcastImage = this.podcastItem.podcastImages[0];
                    }

                    let currentPlayerPosition = 0;

                    clearInterval(this.positionInterval);

                    this.positionInterval = setInterval( () => {
                        if(!this.playerComponent.ifPlayerInit()) return;

                        const currentPosition = this.playerComponent.getCurrentPosition();
                        if(currentPosition == 0) {
                            this.unselectAll();
                            let currentSelectedElement = _.first(this.podcastItem.textItems);
                            currentSelectedElement.isSelected = true;
                            this.podcastItem.currentPodcastImage = currentSelectedElement.image;
                            return;
                        }

                        if (currentPlayerPosition !== currentPosition) {
                            this.unselectAll();
                            let currentSelectedElement = null;
                            this.podcastItem.textItems.forEach( (itemIn: TextItem) => {
                                if (typeof itemIn.time === 'number' && itemIn.time <= currentPosition+0.01) {
                                    currentSelectedElement = itemIn;
                                }
                            });
                            if (currentSelectedElement) {
                                currentSelectedElement.isSelected = true;
                                if(currentSelectedElement.image&&currentSelectedElement.image.url){
                                    this.podcastItem.currentPodcastImage = currentSelectedElement.image;
                                }else{
                                    this._defineCurrentPodcastImage(currentSelectedElement);
                                }
                            }
                            currentPlayerPosition = currentPosition;
                        }
                    }, 100);

                    this.playerChangePositionService.changePosition$.subscribe( (point: PlayerPoint) => {
                        this.podcastItem.textItems.forEach( (item: TextItem) => {
                            if (item.id === point.id) {
                                console.log('ChangePositionSubscribe', point);
                                item.time = point.time;
                            }
                        });
                    });
                    $('body').removeClass('loading');



                }, (error:any) => {
                    const initialState = {
                        title: this.translationService.translate('podcast-information'),
                        type: 'danger',
                        text: error.error.message
                    };

                    this.modalRef = this.modalService.show(ModalComponent, {initialState});
                    $('body').removeClass('loading');
                })




        });

        const that = this;

        // достаем сам подкаст





    }

    ngAfterViewInit() {
        if( !this.globals.previeModeStatus() ){
            const resize = () => {
                const shift = this.previewMode ? 220 : 280;
                $('#textItemContainer, #imageContainer').height( $(window).height() > shift ? ($(window).height() - shift) : 400 );
            }

            resize();

            $(window).resize( (e) => {
                resize();
            });
        }

    }

    skipImage(isReverse = false)
    {
        let currentPodcastImage = this.podcastItem.currentPodcastImage;
        let iterateBreak = false;
        let searchStart = false;
        let prevSelectedItem = null;
        this.podcastItem.textItems.forEach((textItem) => {
            if(searchStart && textItem.image && textItem.image.url && !iterateBreak){
                iterateBreak = true;
                this.unselectAll();
                this.selectItem(textItem);
            }
            if(textItem.image && textItem.image.url && currentPodcastImage.url == textItem.image.url){
                searchStart = true;
                if(isReverse){
                    this.unselectAll();
                    this.selectItem(prevSelectedItem);
                    iterateBreak = true;
                }
            }
            if(textItem.image && textItem.image.url && !searchStart){
                prevSelectedItem = textItem;
            }
        });
    }

    addPoint(item: TextItem) {
        item.time = this.playerComponent.getCurrentPosition();

        this.unselectAll();

        const point = new PlayerPoint();
        // point.labelText = item.getAudioPointText();
        point.time = item.time;
        point.id = item.id;


        this.playerComponent.addPoint(point);
    }

    selectItem(item: TextItem) {
        if(item.time === 0 || item.time){
            this.playerComponent.playerObject.player.seek(item.time);
            this.playerComponent.play();
        }

        if(item.image && item.image.url){
            this.podcastItem.currentPodcastImage = item.image;
            return;
        }

        this._defineCurrentPodcastImage(item);

    }

    removeItem(item: TextItem) {
        this.unlinkImage(item);
        this.playerComponent.removePointById(item.id);
        this.podcastItem.textItems = _.without(this.podcastItem.textItems, item);
    }

    duplicateItem(item: TextItem) {
        let newItem:TextItem = _.clone(item);

        let maxId = 0;
        this.podcastItem.textItems.forEach((textItem) => {
            if(textItem.id > maxId) {
                maxId = textItem.id;
            }
        });
        newItem.id = maxId;
        newItem.isSelected = false;
        newItem.time = null;

        newItem.image = new ImageItem();

        let newTextItems = [];
        this.podcastItem.textItems.forEach((textItem) => {
            newTextItems.push(textItem);
            if(textItem.id == item.id){
                newTextItems.push(newItem);
            }
        });

        this.podcastItem.textItems = newTextItems;

        console.log('Duplicate Item', item);
    }

    showTerminateWindow() {
        const initialState = {
            title: this.translationService.translate('remove-podcast'),
            type: 'danger',
            podcastItem: this.podcastItem
        };
        this.modalRef = this.modalService.show(RemovePodcastComponent, {initialState});
    }

    _defineCurrentPodcastImage(item: TextItem) {
        let currentPodcastImage = this.podcastItem.currentPodcastImage;
        let iterateBreak = false;
        this.podcastItem.textItems.forEach((textItem) => {
            if(textItem.image && textItem.image.url && !iterateBreak){
                currentPodcastImage = textItem.image;
            }
            if(textItem.id == item.id){
                iterateBreak = true;
            }
        });
        this.podcastItem.currentPodcastImage = currentPodcastImage;
    }

    linkImage(item: TextItem) {
        this.podcastItem.podcastImages.forEach((img) => {
            if( img.url == item.image.url ){
                img.isLinked = true;
            }
        });
    }

    unlinkImage(item: TextItem) {
        this.podcastItem.podcastImages.forEach((img) => {
            if( img.url == item.image.url ){
                img.isLinked = false;
            }
        });
        item.image.url = null;
    }

    unselectAll() {
        this.podcastItem.textItems.forEach( (itemIn: TextItem) => {
            itemIn.isSelected = false;
        });
    }

    edit() {
        this.router.navigate(['editor/uploader/' + this.podcastItem.id]);
    }

    save() {
        let dataToSend = [];

        this.podcastItem.textItems.forEach((item) => {
            dataToSend.push({
                id: item.id,
                text: item.text,
                image: item.image.url,
                time: item.time
            });
        });

        this.http
            .post('/editor/save', { id: this.podcastItem.id, parsed : dataToSend } ).subscribe( (result:any) => {
            const initialState = {
                title: this.translationService.translate('create-podcast'),
                type: 'success',
                text: this.translationService.translate('podcast-create-success', {'val1' : result.id})
            };
            this.modalRef = this.modalService.show(ModalComponent, {initialState});
        }, (error) => {
                this._handleError(error.error.message);
        });
    }

    duplicateTextItem() {

    }

    // -----

    onDragStart(e) {
        $(e.target).css('opacity', '0.3');
        e.dataTransfer.setData('img-src', $(e.target).attr('src'));
    }

    onDragEnd(e) {
        $(e.target).css('opacity', '1.0');
    }

    _handleError(error) {
        const initialState = {
            title: 'Ошибка!',
            type: 'danger',
            text: error
        };
        this.modalRef = this.modalService.show(ModalComponent, {initialState});
    }

}
